module.exports = __webpack_public_path__ + "img/redconfirmtop.f74e4861.png";